import { render, staticRenderFns } from "./DescriptionAssuranceSinistre.vue?vue&type=template&id=45d18657&scoped=true"
import script from "./DescriptionAssuranceSinistre.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceSinistre.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceSinistre.vue?vue&type=style&index=0&id=45d18657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d18657",
  null
  
)

export default component.exports